import type { InputHTMLAttributes } from "react";
import { Field } from "react-final-form";
import { Box, Button, FormHelperText } from "@mui/material";
import { FormattedMessage as T } from "react-intl";

type FileFieldProps = {
  name: string;
} & InputHTMLAttributes<HTMLInputElement>;

const FileField = ({ name, ...props }: FileFieldProps) => (
  <Field<File> name={name} type="file">
    {({ meta, input: { value, onChange, ...input } }) => (
      <>
        {meta.error && meta.submitFailed && (
          <Box mr={2}>
            <FormHelperText error>{meta.error}</FormHelperText>
          </Box>
        )}
        <label>
          <input
            style={{ display: "none" }}
            {...input}
            onChange={({ target }) => {
              if (target.files?.length === 1) onChange(target.files[0]);
            }}
            {...props}
          />
          <Button variant="outlined" component="span" size="small">
            <T id="chooseFileButton" />
          </Button>
        </label>
      </>
    )}
  </Field>
);

export default FileField;
